import { workflowComponent } from '@banking/ui/services/instant-payouts-direct-deposit-switch-modal';
import { nextScreenAction, previousScreenAction, closeModalAction, getNavigationIcon, onLocationChangeAction, onSwitchPayoutsAction, hasMultipleLocations } from '@banking/ui/workflows/instant-payouts/direct-deposit-switch-modal';
import { hbs } from 'ember-cli-htmlbars';
const mapStateToProps = state => ({
  currentScreen: state.navigation.currentScreen,
  loading: state.loading,
  modalOpen: state.modalOpen,
  availableIntegrations: state.availableIntegrations,
  selectedIntegration: state.selectedIntegration,
  navigationIcon: getNavigationIcon(state.navigation.currentScreen),
  hasMultipleLocations: hasMultipleLocations(state),
  selectedUnit: state.selectedUnit,
  isOnboardingInstantAccess: state.isOnboardingInstantAccess,
  directDepositAccountInfo: state.directDepositAccountInfo
});
const mapActionsToProps = () => ({
  onNext: () => nextScreenAction(),
  onBack: () => previousScreenAction(),
  onClose: () => closeModalAction(),
  onLocationChange: units => onLocationChangeAction(units),
  onSwitchPayouts: integration => onSwitchPayoutsAction(integration)
});
const template = hbs`
  <Banking::InstantPayouts::DirectDepositSwitchModal
    @active={{this.modalOpen}}
    @loading={{this.loading}}
    @currentScreen={{this.currentScreen}}
    @availableIntegrations={{this.availableIntegrations}}
    @selectedIntegration={{this.selectedIntegration}}
    @navigationIcon={{this.navigationIcon}}
    @hasMultipleLocations={{this.hasMultipleLocations}}
    @selectedUnit={{this.selectedUnit}}
    @isOnboardingInstantAccess={{this.isOnboardingInstantAccess}}
    @directDepositAccountInfo={{this.directDepositAccountInfo}}
    @onLocationChange={{this.onLocationChange}}
    @onBack={{this.onBack}}
    @onNext={{this.onNext}}
    @onClose={{this.onClose}}
    @onSwitchPayouts={{this.onSwitchPayouts}}
  />
`;
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);